import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ArtistProductsSummaryRequest } from 'src/app/Services/artistproducts.service';
import { Artist } from 'src/app/Services/artists.service';
import { AuthService, FCMNotificationActionGroupEnum, ResponseObject } from 'src/app/Services/auth.service';
import { ConnectedNote, ConnectedNotesService } from 'src/app/Services/connected-notes.service';
import { ConnectedGallery, ConnectedGallerySettingRequest, ConnectionsService, InviteExternalUserData } from 'src/app/Services/connections.service';
import { MessagingService } from 'src/app/Services/messaging.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { SubscriptionRulesService } from 'src/app/Services/subscription-rules.service';
import { UsersService } from 'src/app/Services/users.service';
import { NotificationTypes } from 'src/app/app.enums';
import { ChatUser } from 'src/app/models/chatBox.model';
import { StripePlans } from 'src/app/models/stripe.model';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'connected-galleries',
    templateUrl: './connected-galleries.component.html',
    styleUrls: ['./connected-galleries.component.css'],
    providers: [SubscriptionRulesService, UsersService, ConnectedNotesService],
    standalone: false
})
export class ConnectedGalleriesComponent implements OnInit {
  public artistId!: string;
  public galleryId: string | null = null;
  public connectedGalleries: ConnectedGallery[] = [];
  public selectedGallery?: ConnectedGallery;
  public availbleGalleries: SelectItem[] = [];
  public inviteExternalUserData!: InviteExternalUserData;
  public inviteDialogVisible = false;
  public allowedToSendInvitations: boolean = false;
  public isStripeDisplayPlansDialogVisible: boolean = false
  public stripePlans: StripePlans[] = [];
  public inviteExternalUserDialogVisible = false;
  public settingDialogVisible: boolean = false;
  public notesDialogVisible: boolean = false;
  public selectedGallerySettings?: ConnectedGallerySettingRequest;
  public notes: ConnectedNote[] = [];
  public formData!: InviteCommentRequest;
  public selectedUserId: string | null = null;
  public displayEmojiDialog: boolean = false
  public selectedCommentField: 'internal' | 'external' | 'galleryNotes' | null = null;

  constructor(private router: Router,
    private ngxSpinnerService: NgxSpinnerService,
    private confirmationService: ConfirmationService,
    private subscriptionRulesService: SubscriptionRulesService,
    private notificationService: NotificationsService,
    private connectionsService: ConnectionsService,
    private route: ActivatedRoute,
    private messagingService: MessagingService,
    private authService: AuthService,
    private transloco: TranslocoService) {
    this.inviteExternalUserData = new InviteExternalUserData();
    this.formData = new InviteCommentRequest();
  }
  ngOnInit(): void {
    this.reciveNotifications()
    this.route.params.subscribe((params) => {
      this.route.queryParams.subscribe(params => {
        this.selectedUserId = params['userId'] || '';
      });
    });
    if (this.authService.isArtist()) {
      this.artistId = this.authService.getUserId();
      this.getConnectedGalleries(this.artistId);
      this.canSendMoreInvites();

    }
  }

  public reciveNotifications() {
    this.messagingService.handleMarkasReadByActionType(FCMNotificationActionGroupEnum.Connection);
  }

  public openInviteDialog($event: any) {
    if (!this.allowedToSendInvitations) {
      this.displayUpgreadAccountDialog = true;
      return;
    }
    this.galleryId = null;
    this.avalableGalleries();
    this.inviteDialogVisible = true;
  }

  public onCloseStripePaymentDailog($event: boolean) {
    this.isStripeDisplayPlansDialogVisible = $event;
  }

  public openInviteExternalUserDialog($event: any) {
    this.inviteExternalUserDialogVisible = true;
  }

  public closeInviteExternalUserDialog($event: any) {
    this.inviteExternalUserDialogVisible = false;
  }



  public openSettingDialog(rowData: ConnectedGallery) {
    this.selectedGallerySettings = {
      AllowAvailableInventory: rowData.AllowAvalableInventory,
      GalleryNotes: rowData.GalleryNotes,
    };
    this.selectedGallery = rowData;
    this.settingDialogVisible = true;
  }

  public closeSettingDialog() {
    this.settingDialogVisible = false;
  }

  public closeNotesDialog($event: any) {
    this.notesDialogVisible = false;
  }
  public openNotesDialog($event: any) {
    this.notesDialogVisible = true;
    this.selectedGallery = $event
    console.log('$event', this.selectedGallery)
  }

  public saveSettings() {
    if (!this.selectedGallery || !this.selectedGallerySettings) return;
    this.ngxSpinnerService.show();
    this.connectionsService.saveConnectedGallerySettings(this.selectedGallery.Id, this.selectedGallerySettings).subscribe((response: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        if (this.selectedGallery) {
          //update the properties back in the selected gallery object so the list is updated
          this.selectedGallery.AllowAvalableInventory = this.selectedGallerySettings?.AllowAvailableInventory;
          this.selectedGallery.GalleryNotes = this.selectedGallerySettings?.GalleryNotes;
        }
        this.settingDialogVisible = false;
        this.notificationService.showNotification(this.transloco.translate('connectedGalleries.successTitle'), this.transloco.translate('connectedGalleries.changesSaved'), NotificationTypes.Success);
      } else { this.notificationService.showNotification(this.transloco.translate('connectedGalleries.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  private avalableGalleries() {
    this.ngxSpinnerService.show();
    this.connectionsService.getAvailableGalleries(this.artistId).subscribe((res) => {
      this.availbleGalleries = res;
      console.log('Avalable Galleries:', res);
      this.ngxSpinnerService.hide();
    }, (error) => { console.error('Error fetching connected galleries:', error); this.ngxSpinnerService.hide(); });
  }

  public onGallerySelection($event: any) {
    this.galleryId = $event.value;
  }

  public statusFilterOptions: SelectItem[] = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Accepted', value: 'Accepted' },
    { label: 'Sending', value: 'Sending' },
  ];
  public filters: ArtistProductsSummaryRequest = {};

  public onStatusFilterChange($event: any) {
    this.filters.ConnectionStatus = $event.value;
    this.getConnectedGalleries(this.artistId, this.filters);
  }

  private getConnectedGalleries(artistId: string | null = null, filters: ArtistProductsSummaryRequest = {}) {
    this.ngxSpinnerService.show();
    this.connectionsService.getConnectedGalleries(artistId, true, filters).subscribe((connectedGalleries: ConnectedGallery[]) => {
      this.connectedGalleries = connectedGalleries;
      console.log(connectedGalleries);
      this.ngxSpinnerService.hide();
    }, (error) => { console.error('Error fetching connected galleries:', error); this.ngxSpinnerService.hide(); });
  }

  private canSendMoreInvites() {
    this.subscriptionRulesService.canSendMoreInvites().subscribe((isAllowed: boolean) => {
      this.allowedToSendInvitations = isAllowed;
    }, (error) => { console.error(error); });
  }

  public displayUpgreadAccountDialog: boolean = false

  public onUpgradeAccount() {
    this.isStripeDisplayPlansDialogVisible = true;
  }

  public sendInvitation() {
    this.ngxSpinnerService.show();
    this.connectionsService.sendInvite(this.artistId, this.galleryId, this.formData).subscribe((res: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (res.Success) {
        this.inviteDialogVisible = false;
        this.galleryId = null;
        this.avalableGalleries();
        this.getConnectedGalleries(this.artistId);
        this.canSendMoreInvites();
        this.formData = new InviteCommentRequest();
        this.notificationService.showNotification(this.transloco.translate('connectedGalleries.successTitle'), this.transloco.translate('connectedGalleries.invitationSent'), NotificationTypes.Success);
      } else { this.notificationService.showNotification(this.transloco.translate('connectedGalleries.errorTitle'), res.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error('Error fetching For invitation:', error); this.ngxSpinnerService.hide(); });
  }


  public inviteExternalUser() {
    this.ngxSpinnerService.show();
    this.connectionsService.inviteExternalUser(this.inviteExternalUserData).subscribe((res: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (res.Success) {
        this.inviteExternalUserDialogVisible = false;
        this.inviteExternalUserData = new InviteExternalUserData();
        this.notificationService.showNotification(this.transloco.translate('connectedGalleries.successTitle'), this.transloco.translate('connectedGalleries.invitationSent'), NotificationTypes.Success);
      } else { this.notificationService.showNotification(this.transloco.translate('connectedGalleries.errorTitle'), res.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error('Error fetching For invitation:', error); this.ngxSpinnerService.hide(); });
  }






  public openEmojiDialog(commentField: 'internal' | 'external' | 'galleryNotes') {
    this.selectedCommentField = commentField;
    this.displayEmojiDialog = true;
  }

  public addEmoji(emoji: string) {
    console.log('Selected emoji:', emoji);
    if (this.selectedCommentField === 'internal') {
      this.formData.InviteGalleryComment = (this.formData.InviteGalleryComment || '') + emoji;
    } else if (this.selectedCommentField === 'external') {
      this.inviteExternalUserData.InviteExternalComment = (this.inviteExternalUserData.InviteExternalComment || '') + emoji;
    } else if (this.selectedCommentField === 'galleryNotes') {
      this.selectedGallerySettings!.GalleryNotes = (this.selectedGallerySettings?.GalleryNotes || '') + emoji;
    }
    this.displayEmojiDialog = false;
  }

  public closeEmojiDialog($event: any) {
    this.displayEmojiDialog = false;
  }




  public deleteConnectedGallery(rowData: ConnectedGallery) {
    this.confirmationService.confirm({
      message: this.transloco.translate('connectedGalleries.deleteConfirm', { name: rowData.Name }),
      accept: () => {
        this.ngxSpinnerService.show();
        this.connectionsService.deleteConnectedGallery(rowData.Id).subscribe((res: ResponseObject) => {
          this.ngxSpinnerService.hide();
          if (res.Success) {
            this.getConnectedGalleries(this.artistId);
            this.notificationService.showNotification(this.transloco.translate('connectedGalleries.successTitle'), this.transloco.translate('connectedGalleries.galleryDeleted'), NotificationTypes.Success);
          } else { this.notificationService.showNotification(this.transloco.translate('connectedGalleries.errorTitle'), res.ResponseMessage, NotificationTypes.Error); }
        }, (error) => { console.error('Error deleting connected gallery:', error); this.ngxSpinnerService.hide(); this.notificationService.showNotification(this.transloco.translate('connectedGalleries.errorTitle'), this.transloco.translate('connectedGalleries.deleteError'), NotificationTypes.Error); });
      }
    });
  }

/** Address/location for the card, if the list payload carries it (declared model has none yet). */
public galleryLocation(g: ConnectedGallery): string {
  const a: any = g as any;
  return a.Address || a.AddressLine1 || a.Location || a.SuburbTown || a.City || a.State || '';
}

public onViewConsignmentsClicked(rowData: ConnectedGallery) {
  if (rowData.IsInviteAccepted) {
    // Pass the connection so the gallery profile can host the management actions
    // (notes / inventory access / remove) that used to live on the list card.
    this.router.navigate(['/artists', 'gallery', rowData.Id, 'gallery-products'], { state: { connection: rowData } });
  }
  else if (rowData.IsInitiatedByArtist && !rowData.IsInviteAccepted && rowData.UserName) {
    this.router.navigate(['/profile', rowData.UserName]);
  } 
  else {
    this.router.navigate(['/connection-request', rowData.ConnectionId]);
  }
}

  public GoToDetail(rowData: Artist) {
    this.router.navigate(['/connection-request', rowData.ConnectionId])
  }
  public ChatwithGallery(user: ChatUser) {
    this.router.navigate(['/inbox', user.Id]); // Kalakar ki ID ko route parameter ke roop mein bhejo
  }


  // Add these new properties
  public showTermsDialog: boolean = false;
  public selectedGalleryForTerms: string = '';
  // Add this new method
  public onTermsCheckboxChange(rowData: ConnectedGallery, event: any) {
    if (event.checked && !rowData.TermsAcceptanceStatus?.IsAccepted) {
      // If checkbox is checked but terms not accepted, open dialog
      this.selectedGalleryForTerms = rowData.Id;
      this.showTermsDialog = true;
      // Uncheck the checkbox temporarily
      event.source.checked = false;
    }
  }


  // Add these dialog handling methods
  public onTermsDialogAccepted() {
    this.showTermsDialog = false;
    // Refresh the connected galleries to get updated terms status
    this.getConnectedGalleries(this.artistId);
  }

  public onTermsDialogCancelled() {
    this.showTermsDialog = false;
    this.selectedGalleryForTerms = '';
  }
  public onTermsDialogClose() {
    if (this.selectedGallery?.TermsAcceptanceStatus?.IsAccepted === false) {
      console.log('Terms dialog closed without acceptance. Unchecking checkbox for gallery:', this.selectedGallery?.Name);
      this.showTermsDialog = false;
      this.selectedGalleryForTerms = '';
      // Ensure the checkbox is unchecked if terms are not accepted
      this.selectedGallery.TermsAcceptanceStatus.IsAccepted = false;
      console.log('Checkbox state updated. IsAccepted:', this.selectedGallery.TermsAcceptanceStatus.IsAccepted);
    } else {
      console.log('Terms dialog closed. Terms already accepted or no gallery selected.');
    }
  }

  // ---- Presentation helpers for the card layout (no backend change) ----

  /** Read a stat off the runtime GallerySoldAndInventoryData blob (not on the typed model). */
  private galleryStat(g: ConnectedGallery, key: string): number {
    const d: any = (g as any).GallerySoldAndInventoryData;
    const v = d ? d[key] : 0;
    return v ? Number(v) : 0;
  }
  public soldCount(g: ConnectedGallery): number { return this.galleryStat(g, 'NoOfSoldArtworks'); }
  public availableCount(g: ConnectedGallery): number { return this.galleryStat(g, 'NoOfAvailableArtworks'); }
  public earned(g: ConnectedGallery): number { return this.galleryStat(g, 'TotalSoldPriceOfSoldItems'); }

  /** Friendly connection state for the card badge + actions. */
  public connectionState(g: ConnectedGallery): 'connected' | 'sent' | 'invited' {
    if (g.IsInviteAccepted) return 'connected';
    if (g.IsInitiatedByArtist) return 'sent';   // artist invited the gallery, awaiting their accept
    return 'invited';                            // gallery invited the artist, needs a response
  }

  public get acceptedGalleries(): ConnectedGallery[] {
    return (this.connectedGalleries || []).filter(g => g.IsInviteAccepted);
  }
  public get summaryConnectedCount(): number { return this.acceptedGalleries.length; }
  public get summaryWorksPlaced(): number {
    return this.acceptedGalleries.reduce((s, g) => s + this.availableCount(g) + this.soldCount(g), 0);
  }
  public get summarySold(): number {
    return this.acceptedGalleries.reduce((s, g) => s + this.soldCount(g), 0);
  }
  public get summaryEarned(): number {
    return this.acceptedGalleries.reduce((s, g) => s + this.earned(g), 0);
  }

  /** Open the terms-acceptance dialog directly (replaces the old checkbox trigger). */
  public openTermsFor(g: ConnectedGallery): void {
    this.selectedGalleryForTerms = g.Id;
    this.showTermsDialog = true;
  }
}

export class InviteCommentRequest {
  InviteGalleryComment?: string;
  InviteArtistComment?: string;
  ProductSoldComment?: string;
}